import { combineReducers } from "redux";
import eventSlice from "./eventSlice";
import userSlice from "./userSlice";
import createEventSlice from "./createEventSlice";

const rootReducer = combineReducers({
  event: eventSlice,
  user: userSlice,
  createEvent: createEventSlice,
});

export default rootReducer;
